export const SIGNAL_GO_TO_LIVE = 'to_live';

export const SIGNAL_OPEN_DATE_SELECTOR = 'open_date_selector';

export const SIGNAL_GO_LEFT = 'left';

export const SIGNAL_GO_RIGHT = 'right';

export const SIGNAL_GO_TO_MORNING = 'morning';

export const SIGNAL_GO_TO_AFTERNOON = 'afternoon';

export const SIGNAL_GO_TO_EVENING = 'evening';

export const TABS = [SIGNAL_GO_TO_MORNING, SIGNAL_GO_TO_AFTERNOON, SIGNAL_GO_TO_EVENING];
